import reducer from "./reducers";

import * as inscripcionesOps from "./operations";
import * as inscripcionesTypes from "./types";
import * as inscripcionesSelectores from "./selectors";

export { inscripcionesOps, inscripcionesTypes, inscripcionesSelectores };
export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/index.js